/**
 * Permission bit flags — mirrors `cop-32/src/middleware/checkPermission.js` `permissions` exactly.
 * Role rows store a bitmask; `getEffectivePermissions` ORs `accountRoles[].role.permissions`.
 * Bits 0-30 only (bit 31 is unsafe with signed Int32 / JS << 31).
 */
export const PERMISSIONS = {
    VIEW_TASK_FORCE: 1n << 0n,
    MANAGE_TASK_FORCE: 1n << 1n,
    VIEW_PILLAR: 1n << 2n,
    MANAGE_PILLAR: 1n << 3n,
    VIEW_PROJECT: 1n << 4n,
    MANAGE_PROJECT: 1n << 5n,
    VIEW_TASK: 1n << 6n,
    MANAGE_TASK: 1n << 7n,
    VIEW_USER: 1n << 8n,
    MANAGE_USER: 1n << 9n,
    VIEW_ORGANIZATION: 1n << 10n,
    MANAGE_ORGANIZATION: 1n << 11n,
    VIEW_CITY: 1n << 12n,
    MANAGE_CITY: 1n << 13n,
    VIEW_ROLE: 1n << 14n,
    MANAGE_ROLE: 1n << 15n,
    VIEW_CHAT: 1n << 16n,
    MANAGE_CHAT: 1n << 17n,
    VIEW_STORAGE: 1n << 18n,
    MANAGE_STORAGE: 1n << 19n,
    VIEW_REPORT: 1n << 20n,
    VIEW_OCCUPATION: 1n << 21n,
    MANAGE_OCCUPATION: 1n << 22n,
    VIEW_ESCALATION: 1n << 23n,
    MANAGE_ESCALATION: 1n << 24n,
    ASSIGN_PILLAR: 1n << 25n,
    REVIEW_SUBMISSION: 1n << 26n,
    SCORE_TASK: 1n << 27n,
    UPLOAD_EVIDENCE: 1n << 28n,
    VIEW_AUDIT_LOG: 1n << 29n,
    LOCK_ALL_PILLAR: 1n << 30n,
    LOCK_OWN_PILLAR: 1n << 31n,
    VIEW_OWN_TASK: 1n << 32n,
    VIEW_ADMIN_LIST: 1n << 33n,
    VIEW_EXECUTIVE_LIST: 1n << 34n,
    VIEW_TASKFORCE_LIST: 1n << 35n,
    VIEW_PILLAR_LIST: 1n << 36n,
    VIEW_PROJECT_MANAGER_LIST: 1n << 37n,
    VIEW_MEMBER_LIST: 1n << 38n,
    VIEW_USER_WITHOUT_ROLE: 1n << 39n,
    VIEW_USER_WITH_ROLE: 1n << 40n,
    VIEW_ADMIN_DASHBOARD: 1n << 41n,
    VIEW_EXECUTIVE_DASHBOARD: 1n << 42n,
    VIEW_EXECUTIVE_AI_SUMMARY: 1n << 43n,
    VIEW_GLOBAL_DASHBOARD: 1n << 44n,
    VIEW_TASK_FORCE_DASHBOARD: 1n << 45n,
    VIEW_GLOBAL_AI_SUMMARY: 1n << 46n,
    VIEW_PROJECT_MANAGER_DASHBOARD: 1n << 47n,
    USE_AI_ASSISTANT: 1n << 48n,
};

/** Required to access `/admin` portal (seeded Admin role has MANAGE_USER). */
export const ADMIN_PORTAL_PERMISSIONS = [PERMISSIONS.MANAGE_USER];